import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withAppData } from "../../app/withAppData";
class CallToActonV1 extends Component {
  render() {
    const { lang, pageConfig } = this.props.appData;
    const footerConfig =
      pageConfig?.footer?.settings?.translations?.[lang] || {};

    return (
      <div className="ltn__call-to-action-area call-to-action-6 before-bg-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-6 ltn__secondary-bg position-relative text-center---">
                <div className="coll-to-info text-color-white">
                  <h1>{footerConfig.title || "Bizimle iletişime geçiniz"}</h1>
                  <p>
                    {footerConfig.content ||
                      "Daha detaylı ürün katalogları ve satış bilgileri için iletişime geçebilirsiniz."}
                  </p>
                </div>
                <div className="btn-wrapper go-top">
                  <Link className="btn btn-effect-3 btn-white" to="/iletisim">
                    {footerConfig.buttonText || "İletişime geçiniz"}{" "}
                    <i className="icon-next" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withAppData(CallToActonV1);
